<template>
  <div class="case-card">
    <template v-for="item in caseCardList" >
      <div class="case-warp" @click="chooseCard(item.id)" :class="item.id == cardId ? 'case-item-on' : ''" v-if="item.type_id < 6">
        <div class="case-item">
          <img v-if="item.id == cardId" :src="item.type_id == 1 ? cardList.sz[1].url :
              item.type_id == 2 ? cardList.fz[1].url :
              item.type_id == 3 ? cardList.hz[1].url :
              item.type_id == 4 ? cardList.tx[1].url :
              item.type_id == 5 ? cardList.sj[1].url :
              item.type_id == 6 && caseDetailValue.first_case_type == 4 ? cardList.gnkl[1].url :
              item.type_id == 7 && caseDetailValue.first_case_type == 4 ? cardList.yxkl[1].url : cardList.jzq[1].url
              " alt="" class="case-item-img">
          <img v-else :src="item.type_id == 1 ? cardList.sz[0].url :
              item.type_id == 2 ? cardList.fz[0].url :
              item.type_id == 3 ? cardList.hz[0].url :
              item.type_id == 4 ? cardList.tx[0].url :
              item.type_id == 5 ? cardList.sj[0].url :
              item.type_id == 6 && caseDetailValue.first_case_type == 4 ? cardList.gnkl[0].url :
              item.type_id == 7 && caseDetailValue.first_case_type == 4 ? cardList.yxkl[0].url : cardList.jzq[0].url
              " alt="" class="case-item-img">
          <div v-if="item.show_not_pass" class="card-status iconfont icon-weitongguo">未通过</div>
          <div class="card-name">
            <div class="card-dot"
                 :class="item.type_id == 1?'dot-shouzhen' :
                     item.type_id == 2?'dot-fuzhen' :
                     item.type_id == 3?'dot-huizhen' :
                     item.type_id == 4?'dot-tuxiang' :
                     item.type_id == 5?'dot-qixie' :
                     item.type_id == 6?'dot-jiaozhi' : 'dot-yinxing'
"                 ></div>
            {{ item.type_name }}
          </div>
          <div class="card-time">{{ item.card_date }}</div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import {GetCaseCardList} from "@/http/api";
import {cardList} from '@/assets/js/case-card'
export default {
  name: "Card",
  data(){
    return{
      list:[],
      cardId:'',
      cardList: cardList,
      caseCardList:[]
    }
  },
  props:{
    id:null,
    card_id:{
      default:undefined,
      type:Number
    },
    caseDetailValue:{
      default:{},
      type:Object
    }
  },
  mounted() {
    this.cardId = this.card_id
    this.initCaseCardData()
  },
  methods:{
    initCaseCardData(){
      this.caseCardList = []
      GetCaseCardList({patient_id:this.id,type_id:0,pageSize:999}).then(res=>{
        this.caseCardList = res.data
        if(!this.cardId){
          this.chooseCard(res.data[0].id)
          this.$emit('cardId',res.data[0].id)
        }
      })
    },
    chooseCard(id){
      this.cardId = id
      this.$emit('cardId',id)
    }
  }
}
</script>

<style scoped>
@import '../../../assets/css/case.css';
</style>
